import {HttpClient} from "../../service/httpClient/HttpClient";
import {setLoadingStateDispatch} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes} from "../../context/SnackBarContext";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

export class CheckoutListService {
    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpClient = new HttpClient()
    }


    getCheckoutList(fundID, page, size = 20) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/settlement-requests`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    page: page,
                    size: size
                }
            ).then(response =>
                resolve(response))
                .catch(reason => {
                    reject(reason)
                })
        })
    }

    getCheckoutInfo(fundID, checkoutId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/settlement-requests/${checkoutId}`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    rejectSettlementRequest(fundID, settlementRequestId) {
        this.loading(setLoadingStateDispatch(true))
        this.httpClient.put(
            `fund-presentation/funds/${fundID}/settlement-requests/${settlementRequestId}/reject`,
            this.httpClient.prepareUserAccessHeader(this.token)
        ).then(response => {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "درخواست تسویه با موفقیت رد شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در رد درخواست تسویه حساب!", this.snackbar, this.loading)
        })
    }

    acceptSettlementRequest(fundID, settlementRequestId) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `fund-presentation/funds/${fundID}/settlement-requests/${settlementRequestId}/accept`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }
}

export const checkoutStatus = {
    "AWAITING_FOR_REVIEW": {
        id: "AWAITING_FOR_REVIEW",
        title: "در دست بررسی"
    }, "ACCEPTED": {
        id: "ACCEPTED",
        title: "پذیرفته شده"
    }, "REJECTED": {
        id: "REJECTED",
        title: "رد شده"
    }, "CANCELLED": {
        id: "CANCELLED",
        title: "لغو شده"
    },
}